/*
* @描述: 公司管理列表
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-24 17:49:49
*/
<template>
    <div class="page_container" v-loading="loading">
        <el-form size="small"
                 @submit.native.prevent
                 :inline="true">
            <div class="flex_js_wrap">
                <div>
                    <el-form-item>
                        <el-input placeholder="请输入关键字" v-model="keyWord"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleClickSearch">搜索</el-button>
                        <el-button @click="handleClickReset">重置</el-button>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="handleClickAddCompany">新增公司</el-button>
                </el-form-item>
            </div>
        </el-form>
        <el-table :data="tableData" border :height="tableHeight">
            <el-table-column label="编号" prop="company_id" align="center" width="100"></el-table-column>
            <el-table-column label="公司名称" prop="name" align="center" min-width="150"></el-table-column>
            <el-table-column label="小程序名称" prop="wxapp_name" align="center" min-width="200"></el-table-column>
            <el-table-column label="公司码" prop="code" align="center" min-width="150"></el-table-column>
            <el-table-column label="管理员人数" prop="roleUserCount" align="center" min-width="100">
                <template slot-scope="{row}">
                    <span class="theme_color" @click="getRoleUserlist(row)">{{ row.roleUserCount }}</span>
                </template>
            </el-table-column>
            <el-table-column label="公司人数" prop="userCount" align="center" min-width="100">
                <template slot-scope="{row}">
                    <span class="theme_color" @click="getUserList(row)">{{ row.userCount }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="90">
                <template slot-scope="{row}">
                    <el-button type="text" size="mini" @click="handleClickEdit(row.company_id)">编辑</el-button>
                    <el-dropdown style="margin-left: 5px" placement="bottom" trigger="click">
                        <el-button type="text" icon="el-icon-more"></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleClickInvite(row)">邀请</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClickWxapp(row)">小程序管理</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClickWxOfficial(row)">公众号管理</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClickDel(row.company_id)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pagination.pageNum"
                       :page-sizes="pagination.pageSizes"
                       :page-size="pagination.pageSize"
                       :layout="pagination.layout"
                       :total="pagination.total">
        </el-pagination>
        <AddCompany :addVisible.sync="addVisible" @success="getTableData" v-if="addVisible"/>
        <EditCompany :editVisible.sync="editVisible" :companyId="companyId" @success="getTableData" v-if="editVisible"/>
        <Personnel :personnelVisible.sync="personnelVisible"
                   :companyId="companyId"
                   :role_id="admin_role_id"
                   v-if="personnelVisible"/>
        <RolePersonnel :rolePersonnelVisible.sync="rolePersonnelVisible"
                       :companyId="companyId"
                       v-if="rolePersonnelVisible"/>
        <Wxapp :wxappVisible.sync="wxappVisible"
               :companyId="companyId"
               @success="getTableData"
               :storeWxappId="storeWxappId"
               v-if="wxappVisible"/>
        <WxOfficial :wxOfficialVisible.sync="wxOfficialVisible"
                    :companyId="companyId"
                    @success="getTableData"
                    v-if="wxOfficialVisible"
                    :officialAccountId="officialAccountId"/>
        <WxInvite :wxInviteVisible.sync="wxInviteVisible"
                  :companyId="companyId"
                  :companyUrl="companyUrl"
                  @success="getTableData"
                  v-if="wxInviteVisible"/>
    </div>
</template>
<script>
    import {getTableStateHeight} from '@/utils'
    import {pagination} from '@/mixins'
    import {DelCompany, ReqCompanyList} from '@/api'
    import AddCompany from './addCompany'
    import EditCompany from './editCompany'
    import Personnel from './personnel.vue'
    import RolePersonnel from './rolePersonnel.vue'
    import Wxapp from './wxApp.vue'
    import WxInvite from './wxInvite.vue'
    import WxOfficial from './wxOfficial.vue'

    export default {
        name: 'Company',
        mixins: [pagination],
        components: {
            AddCompany,
            EditCompany,
            Personnel,
            RolePersonnel,
            Wxapp,
            WxInvite,
            WxOfficial,
        },
        data() {
            return {
                keyWord: '',
                tableData: [],
                tableHeight: undefined,//table高度
                loading: false,//加载动画
                resizeTimer: null, //节流定时器
                addVisible: false,
                editVisible: false,
                companyId: 0,
                admin_role_id: 0,
                personnelVisible: false,
                rolePersonnelVisible: false,
                wxappVisible: false,
                storeWxappId: 0,
                wxInviteVisible: false,
                wxOfficialVisible: false,
                officialAccountId: 0,
                companyUrl: ''
            }
        },
        mounted() {
            this.tableHeight = getTableStateHeight('page_container', 'el-form', 67)
            this.getTableData()
            window.onresize = () => {
                if (this.resizeTimer) {
                    clearTimeout(this.resizeTimer)
                }
                //开启定时器，节流函数
                this.resizeTimer = setTimeout(() => {
                    //将计算的table高度赋值给table
                    this.tableHeight = getTableStateHeight('page_container', 'el-form', 67)
                    //清除定时器
                    this.resizeTimer = null
                }, 100)
            }
        },
        methods: {
            getTableData() {
                this.loading = true
                ReqCompanyList({
                    keyWord: this.keyWord,
                    page: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                }).then(res => {
                    if (res.code === 200) {
                        const {
                            data,
                            total
                        } = res.data
                        this.tableData = data
                        this.pagination.total = total
                        this.storeWxappId = 0
                        this.companyId = 0

                    }
                    this.loading = false
                })
            },

            handleClickSearch() {
                this.pagination.pageNum = 1
                this.getTableData()
            },

            handleClickReset() {
                this.keyWord = ''
                this.pagination.pageNum = 1
                this.getTableData()
            },

            handleClickAddCompany() {
                this.addVisible = true
            },

            handleClickEdit(id) {
                this.companyId = id
                this.editVisible = true
            },

            handleClickDel(company_id) {
                this.$confirm('确定删除公司吗', '提示', {
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    type: 'error'
                }).then(() => {
                    DelCompany({
                        company_id
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('删除成功')
                            this.getTableData()
                        }
                    })
                }).catch(() => {
                    return false
                })
            },

            handleSizeChange(val) {
                this.pagination.pageNum = 1
                this.pagination.pageSize = val
                this.getTableData()
            },

            handleCurrentChange(val) {
                this.pagination.pageNum = val
                this.getTableData()
            },
            // 获取公司管理员人数详细列表
            getRoleUserlist(row) {
                this.companyId = row.company_id
                this.rolePersonnelVisible = true
            },
            // 获取公司人数详细列表
            getUserList(row) {
                this.companyId = row.company_id
                this.admin_role_id = row.admin_role_id
                this.personnelVisible = true
            },
            // 邀请
            handleClickInvite(row) {
                this.companyId = row.company_id
                this.companyUrl = row.url + '&type=invite'
                this.wxInviteVisible = true
            },
            // 小程序管理
            handleClickWxapp(row) {
                this.companyId = row.company_id
                this.storeWxappId = row.store_wxapp_id
                this.wxappVisible = true
            },
            // 公众号管理
            handleClickWxOfficial(row) {
                this.companyId = row.company_id
                this.officialAccountId = row.official_account_id
                this.wxOfficialVisible = true
            },
        },
    }
</script>
<style lang="scss" scoped>

</style>
